import { api } from "@/lib/axios";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export const useUpdateCredits = () => {
  return useMutation({
    mutationFn: async (credits: number) => {
      const response = await api.post<{ url: string }>(
        "/api/payment/checkout",
        {
          credits,
        }
      );

      return response.data;
    },

    onSuccess: (data) => {
      window.location.href = data.url;
    },

    onError: () => {
      toast.error("Failed to update credits");
    },
  });
};
